import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { queryClient } from "../../../App";
import SwitchDefaultEmployerRequest from "../request/SwitchDefaultEmployerRequest";

const SwitchDefaultEmployerApiService = async (
  request: SwitchDefaultEmployerRequest
): Promise<boolean> => {
  const url = "/users/multi_employer_user/assign/";
  const { data } = await axios.put(url, request);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useSwitchDefaultEmployerApiService = () =>
  useMutation<boolean, AxiosError, SwitchDefaultEmployerRequest>(
    SwitchDefaultEmployerApiService,
    {
      mutationKey: ["SwitchDefaultEmployerApiService"],
      onSuccess: () => {
        queryClient.refetchQueries(["AuthUserProfileApiService"]);
      },
    }
  );

export default useSwitchDefaultEmployerApiService;
